import React, { useEffect, useState } from 'react';
import { IonContent, IonHeader, IonPage } from '@ionic/react';
import { RouteComponentProps } from 'react-router-dom';
import LogItemList from '../components/LogItemList';
import { IActivityLogSearchResult, ILogSearch_Response} from '../domain/ActivityLog';
import HeaderSimple from '../components/HeaderSimple';
import { Plugins } from '@capacitor/core';
import { DataAccessService } from '../services/dataAccessService';
import { ActivityTypes, EnumTimePeriods, EnumPersons } from '../domain/enums';

import './css/common.css';

const { Network } = Plugins;

interface ResultsProps extends RouteComponentProps {
    type:string
}


const Results: React.FC<ResultsProps> = ({history, location, match}) => {
    const [neededList, setNeededList] = useState([] as IActivityLogSearchResult[]);
    const [isOnline, setIsOnline] = useState<boolean>(window.localStorage.getItem("online") !== "0");
    const [hasBeenRefreshed, setHasBeenRefreshed] = useState(false);

    useEffect(() => {
        Network.addListener("networkStatusChange", status => {
        setIsOnline(status.connected);
        if (status.connected)
            window.localStorage.setItem("online", "1");
        else
            window.localStorage.setItem("online", "0");
        });

        return () => Network.removeAllListeners();
    },[])

    useEffect(() => {
        let myList = [] as IActivityLogSearchResult[];
        let storageList = window.localStorage.getItem("activityLogList");
        if (storageList) {
            myList = JSON.parse(storageList.toString()) as IActivityLogSearchResult[];
        }
        setNeededList(myList);
            //setRefreshBool(false);
    },[isOnline]);

    //update pin value after delete
    useEffect(() => {
        let _token = window.localStorage.getItem("token");
        let _client = window.localStorage.getItem("defaultClient") ? String(window.localStorage.getItem("defaultClient")) : '-1';
    
        if (hasBeenRefreshed && isOnline) {
          new DataAccessService().getActivityLogList(String(_token), _client, EnumTimePeriods.All.toString(), '','', EnumPersons.All.toString(), '', Number(ActivityTypes.All), true , '', false)
          .then(
                function (expectedData) {
                    if (expectedData) {
                      let activityLogPinnedList = (JSON.parse(expectedData.toString()) as ILogSearch_Response).Results as IActivityLogSearchResult[];
                      if (activityLogPinnedList.length > 0) {
                        window.localStorage.setItem("pinValue", activityLogPinnedList.length.toString());
                      } 
                    }
                  },
                function (response) {}
          );
        }
    },[hasBeenRefreshed, isOnline])
    
    const refresh = (id:number, isDelete:boolean = true) => {
        setHasBeenRefreshed(false);
        if (id !== 0 && isDelete) {
            setNeededList(neededList.filter((x) => x.ActivityLogID !== id)); 
            window.localStorage.setItem("activityLogList", JSON.stringify(neededList));
            setHasBeenRefreshed(true);
        }
    }

    return (
        <IonPage>
            <IonHeader mode="ios">
                <HeaderSimple headerTitle="Search results" history={history} 
                        location={location} match={match}></HeaderSimple>
            </IonHeader>
            <IonContent fullscreen>
                <LogItemList resultList={neededList} history={history} location={location} match ={match} refresh={refresh}></LogItemList>
            </IonContent>
        </IonPage>
    );
};
export default Results;